import { useState, useEffect } from "react";
import * as helper from '../global/helper';
import Select from 'react-select';
import Swal from 'sweetalert2';
import swal from 'sweetalert2';
import { getMatCancellationSheet } from "../api/matAPI";
import BookingBar from "./bookingBar";
import EditCancellation from "./editCancellation";

const MatCancellationSheet = (props) => {

    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [isInit,                          setIsInit]                   = useState(true);
    const [cancellationSheet,               setCancellationSheet]        = useState([]);
    const [cancellationTable,               setCancellationTable]        = useState(null);
    const [cancellationDetails,             setCancellationDetails]      = useState(null);
    const [rateDetails,                     setRateDetails]              = useState({
        totalAmount: 0,
        totalSGST: 0,
        totalCGST: 0,
        finalAmount: 0,
        fromDate: '',
        toDate: '',
        totalCancellation: 0,
        type: "Total Cancellation"
    });

    useEffect(() => {
        if (cancellationSheet.length > 0) {
            const totalAmount = cancellationSheet.reduce((sum, item) => sum + item.TotalAmount, 0);
            const totalSGST = cancellationSheet.reduce((sum, item) => sum + item.Tax / 2, 0); // Assuming 9% SGST
            const totalCGST = cancellationSheet.reduce((sum, item) => sum + item.Tax / 2, 0); // Assuming 9% CGST
            const finalAmount = cancellationSheet.reduce((sum, item) => sum + item.FinalAmount, 0);

            setRateDetails({
                totalAmount,
                totalSGST,
                totalCGST,
                finalAmount,
                fromDate: cancellationSheet[0].BillDate.split('T')[0], // Example: Get first entry date
                toDate: cancellationSheet[cancellationSheet.length - 1].BillDate.split('T')[0],
                totalCancellation: cancellationSheet.length,
                type: "Total Cancellation"
            });
        }
    }, [cancellationSheet]);

    useEffect(() => {
        props.title('Range Cancellation Sheet ','mat-cancel-sheet')
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        }); 
    },[])
    
    useEffect(() => {       
        if (!isInit) {
            fillTable();
        }
    }, [cancellationSheet]);

    useEffect(() => {
        if(selectedFromDate && selectedToDate){
            fetchCancellationSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }
    },[selectedFromDate, selectedToDate])

    const fetchCancellationSheet = async(fdate, tDate) => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const booking = await getMatCancellationSheet(fdate, tDate);
            isInit ? setIsInit(false) : $('#tblCancelSheet').KTDatatable().destroy(); 
            setCancellationSheet(booking)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    function exportSheet(type) {
        cancellationTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Mat Cancellation Sheet` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    function fillTable() {

        // var startType = $('#ddlStart').val();
        var filteredList = cancellationSheet;
        var tableFields = []

        Swal.close();

        $.each(filteredList, function (index, element) {

            if (element.Status != null) {
                element["Status"] = '<div class="badge badge-danger"><span>' + element["Status"] + '</span></div>';
            }

        });

        tableFields = [{ field: "Slot", title: "Slot", width: 60 } ]

        Config.Core.InitPopover();

        const dataTable = $('#tblCancelSheet').KTDatatable({
            
            data: {
                saveState: false,
                source: filteredList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'CreatedDate',
                    title: "Bill Dt",
                    width: 75,
                    template: function (row) {
                        return moment(row.CreatedDate).format('DD-MM-YYYY');
                    }
                },
                {
                    field: 'CancelDate',
                    title: "Cancel Dt",
                    width: 75,
                    template: function (row) {
                        return moment(row.CancelDate).format('DD-MM-YYYY');
                    }
                },
                {
                    field: 'GameDate',
                    title: "Game Dt",
                    width: 75,
                    template: function (row) {
                        return moment(row.GameDate).format('DD-MM-YYYY');
                    }
                }, 
                {  field: 'Slot',  title: 'Slot',
                    template: function (row) {
                        return `${row.SlotFrom} To ${row.SlotTo}`
                    },
                    width: 70 
                },
                {
                    field: 'TypeName',
                    title: 'Type',
                    width: 60,
                },
                {
                    field: 'MatNumber',
                    title: 'Way',
                    width: 50,
                },
                { field: "Player", title: "Player", width: 100,},
                { field: "SubCategoryName", title: "PlayerSubCategory", width: 100,},
                {
                    field: 'MembershipNo',
                    title: 'Mem.No',
                    width: 60,
                },
                {
                    field: 'BookedBy',
                    title: 'Booked By',
                    width: 90,
                },
                {
                    field: 'Bucket',
                    title: 'Bucket',
                    width: 45,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? !!row?.Bucket ? row?.Bucket : '' : ''}</strong>`
                    }
                },
                {
                    field: 'Club',
                    title: 'Club',
                    width: 40,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? (row?.Club == 1 ? 'Yes' : !!row?.Bucket ? 'No' : '') : ''}</strong>`
                    }
                },
                {
                    field: 'PaymentType',
                    title: 'Pay. Type',
                    width: 50,
                },
                {
                    field: 'PaymentMode',
                    title: 'Pay. Mode',
                    width: 70,
                },
                {
                    field: 'TrackingID',
                    title: 'Tracking ID',
                    width: 150,
                },
                {
                    field: 'BillNo',
                    title: 'Bill No',
                    width: 140,
                },
                {
                    field: 'BillAmount',
                    title: 'Bill Amt',
                    width: 70,
                },
                {
                    field: 'RefundAmount',
                    title: 'Refund Amt',
                    width: 50,
                },
                {
                    field: 'RefundRefNo',
                    title: 'Refund Ref.No',
                    width: 50,
                },
                {
                    field: 'RefundStatus',
                    title: 'Refund Sts',
                    template: function (row) {
                        if (row.RefundStatus === "Pending") {
                            return "<div class='badge badge-warning'><span>Pending</span></div>";
                        } else {
                            return "<div class='badge badge-success'><span>success</span></div>";
                        }
                    },
                    width: 70,
                },
                {
                    field: '',
                    title: '',
                    width: 50,
                    class: "clickable",
                    template: function (row) {
                        return showEditButton(row)
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
            
        });
        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');
        function showEditButton(row) {

            var optString = '';
            optString += '<center>'
            optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`
            optString += '</center>'
            return optString;
        }
        // export to excel
        const CancellationTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Mat Cancellation Sheet`,
        });
        setCancellationTable(CancellationTable);
        $('.tableexport-caption').addClass('hidden');
        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setCancellationDetails(dataTable.dataSet[index]) 
                
            } 
        });
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group  col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <BookingBar
                                rateDetails={rateDetails}
                            />
                            <div id="tblCancelSheet" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
            {!!cancellationDetails && (
                <EditCancellation
                    cancellationDetails={cancellationDetails}
                    onDismissModal={setCancellationDetails}
                    refetchData={() => fetchCancellationSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))}
                />
            )}
        </>
    )
}

export default MatCancellationSheet